
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(4(09|23|610|984)|5(329|420|49)|8(012|31|928|983)|3(242|278|828|970)|(148|213|630|944)6|1927|2472|7397)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
